// @flow

import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { css } from '@emotion/core'
import Feature from '@/components/Feature'
import MediaBlockWithVideo from '@/components/MediaBlockWithVideo'
import PhotoCollage from '@/components/PhotoCollage'

export function CarrerPageFeature() {
  const {
    page: {
      data: {
        heroTitle,
        qrCode,
        heroDescription: { html: heroDescription },
        heroPhoto: { url: heroPhoto },
        heroVideo,
        adCodeBlock,
        collage
      },
    },
  } = useStaticQuery(query)
  const mediaBlock = (
    <MediaBlockWithVideo
      src={heroPhoto}
      alt=""
      ctaLabel="Watch Video"
      videoTitle="Embedded Video"
      embedHtml={heroVideo}
    />
  )
  const collageBlock = (
    <PhotoCollage
      styles={WorkingHereStyles}
      photos={collage.map(c => c.photo)}
    />
  )
  return (
    <Feature
      wrapperBackground
      hero={true}
      title={heroTitle}
      largeTitle
      titleAccent
      description={
        <div dangerouslySetInnerHTML={{ __html: qrCode + heroDescription + adCodeBlock }} />
      }
      mediaBlock={mediaBlock}
      collageBlock={collageBlock}
    />
  )
}

const query = graphql`
  {
    page: prismicCareers {
      data {
        title {
          text
        }
        heroTitle: hero_title
        qrCode: careers_qr_code
        heroDescription: hero_description {
          html
        }
        heroPhoto: hero_photo {
          url
        }
        heroVideo: hero_video
        adCodeBlock: adcodeblock
        collage: collage {
          photo: collage_photo {
            url
          }
        }
      }
    }
  }
`

const WorkingHereStyles = css`
  background-color: #fff;
  margin-bottom: -60px;
  grid-template-columns: 1fr 1fr 2fr;
  img {
    padding-bottom: 30px;
    &:nth-of-type(1) {
      grid-area: 1 / 1 / 2 / 2;
    }
    &:nth-of-type(2) {
      grid-area: 1 / 2 / 2 / 3;
    }
    &:nth-of-type(3) {
      grid-area: 1 / 3 / 3 / 4;
    }
    &:nth-of-type(4) {
      grid-area: 2 / 1 / 3 / 3;
    }
  }
`
